<app-side-menu>
  <div class="budget-create-content">

    <div class="page-header">
      <div class="page-header__text">
        <button type="button" class="btn btn-link back-link" (click)="cancel()">
          <i class="fas fa-arrow-left me-1"></i>
          {{ isEditMode ? 'Voltar para o orçamento' : (linkedAppointmentId ? 'Voltar para agendamentos' : 'Voltar para orçamentos') }}
        </button>
        <h1 class="page-title">{{ isEditMode ? 'Editar orçamento B2B' : 'Novo orçamento B2B' }}</h1>
        <p class="page-subtitle" *ngIf="isEditMode">
          Altere serviços e peças. Contrato, placa e tipo de OS não mudam porque a ordem de serviço já existe.
          Ao salvar, o orçamento volta para <strong>Pendente</strong> para nova análise do cliente.
        </p>
        <p class="page-subtitle" *ngIf="!isEditMode && !linkedAppointmentId">
          Preencha contrato, placa, tipo de execução e os itens. O sistema cria a OS,
          a seção de trabalho e o orçamento em status <strong>Pendente</strong>.
        </p>
        <p class="page-subtitle" *ngIf="linkedAppointmentId">
          Orçamento a partir do agendamento #{{ linkedAppointmentId }}. Contrato e placa já vêm
          preenchidos; ao salvar, a OS fica vinculada ao agendamento.
        </p>
        <span class="badge execution-badge" [class.execution-badge--base]="!isThirdPartyOS" [class.execution-badge--partner]="isThirdPartyOS">
          {{ executionTypeLabel }}
        </span>
      </div>
    </div>

    <app-loading [show]="loadingEdit" message="Carregando orçamento..."></app-loading>

    <form [formGroup]="form" (ngSubmit)="submit()" *ngIf="form && !loadingEdit">
      <div class="form-card">
        <h6 class="form-card__title">
          <i class="fas fa-file-contract"></i>
          Contrato e veículo
        </h6>

        <div class="row g-3">
          <div class="col-md-6">
            <label class="form-label" for="contract">Contrato B2B *</label>
            <select
              id="contract"
              class="form-select"
              formControlName="b2bContractId"
              (change)="onContractChange()">
              <option [ngValue]="null">
                {{ loadingContracts ? 'Carregando contratos...' : 'Selecione o contrato' }}
              </option>
              <option *ngFor="let c of contractOptions" [ngValue]="c.id">{{ c.label }}</option>
            </select>
            <div class="invalid-feedback d-block" *ngIf="isInvalid('b2bContractId')">
              Contrato obrigatório.
            </div>
          </div>

          <div class="col-md-6">
            <app-b2b-contract-plate-select
              formControlName="plate"
              [contractId]="contractId"
              [prefillOption]="selectedPlateOption"
              [required]="true"
              [allowEmpty]="true"
              emptyLabel="Selecione a placa"
              (plateSelected)="onPlateSelected($event)">
            </app-b2b-contract-plate-select>
            <div class="invalid-feedback d-block" *ngIf="isInvalid('plate')">
              Placa obrigatória.
            </div>
            <small class="text-muted d-block mt-1" *ngIf="selectedPlateOption?.model">
              {{ selectedPlateOption?.model }}
            </small>
          </div>
        </div>
      </div>

      <div class="form-card">
        <h6 class="form-card__title">
          <i class="fas fa-screwdriver-wrench"></i>
          Ordem de serviço e oficina
        </h6>

        <div class="row g-3">
          <div class="col-md-6">
            <label class="form-label" for="configOrder">Tipo de OS *</label>
            <select
              id="configOrder"
              class="form-select"
              formControlName="configOrderId"
              (change)="onConfigOrderChange()">
              <option [ngValue]="null">
                {{ loadingConfigs ? 'Carregando tipos...' : 'Selecione o tipo de OS' }}
              </option>
              <option *ngFor="let cfg of configOrderOptions" [ngValue]="cfg.id">
                {{ cfg.typeOS || ('Tipo #' + cfg.id) }}{{ cfg.isThirdParty ? ' (parceiro)' : ' (base)' }}
              </option>
            </select>
            <div class="invalid-feedback d-block" *ngIf="isInvalid('configOrderId')">
              Tipo de OS obrigatório.
            </div>
          </div>

          <div class="col-md-6">
            <label class="form-label" for="openingReason">Motivo de abertura</label>
            <select id="openingReason" class="form-select" formControlName="openingReason">
              <option value="">
                {{ loadingOpeningReasons ? 'Carregando motivos...' : 'Sem motivo específico' }}
              </option>
              <option *ngFor="let reason of openingReasonOptions" [value]="reason">{{ reason }}</option>
            </select>
            <small class="text-muted d-block mt-1" *ngIf="!loadingOpeningReasons && configOrderId && openingReasonOptions.length === 0">
              Nenhum motivo cadastrado para este tipo de OS.
            </small>
          </div>

          <div class="col-12" *ngIf="isThirdPartyOS">
            <label class="form-label">Oficina parceira *</label>

            <div class="provider-card" *ngIf="selectedProvider; else providerEmpty">
              <div class="provider-card__body">
                <div class="provider-card__name">
                  <i class="fas fa-building me-2"></i>
                  {{ providerLabel }}
                </div>
                <div class="provider-card__meta">
                  <span *ngIf="selectedProvider.cnpj"><strong>CNPJ:</strong> {{ selectedProvider.cnpj }}</span>
                  <span *ngIf="selectedProvider.phone"><strong>Telefone:</strong> {{ selectedProvider.phone }}</span>
                  <span *ngIf="selectedProvider.serviceType"><strong>Serviço:</strong> {{ selectedProvider.serviceType }}</span>
                  <span *ngIf="selectedProvider.servedStates"><strong>UFs:</strong> {{ selectedProvider.servedStates }}</span>
                </div>
              </div>
              <div class="provider-card__actions">
                <button type="button" class="btn btn-outline-primary btn-sm" (click)="openProviderPicker()" [disabled]="submitting || isEditMode">
                  <i class="fas fa-exchange-alt me-1"></i> Trocar
                </button>
                <button type="button" class="btn btn-outline-secondary btn-sm" (click)="clearSelectedProvider()" [disabled]="submitting || isEditMode">
                  <i class="fas fa-times me-1"></i> Limpar
                </button>
              </div>
            </div>

            <ng-template #providerEmpty>
              <div class="provider-empty">
                <div class="provider-empty__text">
                  <i class="fas fa-store-slash"></i>
                  Nenhuma oficina selecionada
                </div>
                <button type="button" class="btn btn-primary btn-sm" (click)="openProviderPicker()" [disabled]="submitting || isEditMode">
                  <i class="fas fa-search me-1"></i> Selecionar oficina
                </button>
              </div>
            </ng-template>
          </div>

          <div class="col-12" *ngIf="!isThirdPartyOS">
            <div class="base-execution-note">
              <i class="fas fa-warehouse me-2"></i>
              Este orçamento será executado na <strong>base (oficina própria)</strong>.
              Não é necessário selecionar prestador externo.
            </div>
          </div>
        </div>
      </div>

      <div class="form-card">
        <div class="form-card__header">
          <h6 class="form-card__title">
            <i class="fas fa-list-check"></i>
            Serviços orçados
          </h6>
          <div class="d-flex gap-2 flex-wrap">
            <button type="button" class="btn btn-outline-primary btn-sm" (click)="addService()">
              <i class="fas fa-plus me-1"></i> Adicionar serviço
            </button>
            <button
              type="button"
              class="btn btn-outline-secondary btn-sm"
              (click)="addGuinchoService()"
              [disabled]="hasGuinchoLine()">
              <i class="fas fa-truck-pickup me-1"></i> Adicionar guincho
            </button>
          </div>
        </div>

        <div formArrayName="services">
          <div
            class="line-item"
            *ngFor="let line of services.controls; let i = index"
            [formGroupName]="i"
            [class.line-item--preventiva]="isPreventiva(line)"
            [class.line-item--guincho]="isGuinchoLine(line)">
            <div class="line-item__number">
              {{ isGuinchoLine(line) ? 'Guincho' : ('Serviço ' + (i + 1)) }}
              <span class="line-kind-badge" *ngIf="!isGuinchoLine(line)" [class.line-kind-badge--preventiva]="isPreventiva(line)">
                {{ isPreventiva(line) ? 'Preventiva' : 'Corretiva' }}
              </span>
              <span class="line-kind-badge line-kind-badge--guincho" *ngIf="isGuinchoLine(line)">Guincho</span>
            </div>
            <div class="row g-3 align-items-start" *ngIf="isGuinchoLine(line)">
              <div class="col-md-8">
                <label class="form-label">Fornecedor de guincho *</label>
                <div class="provider-card provider-card--compact" *ngIf="line.get('guinchoProviderId')?.value; else guinchoEmpty">
                  <div class="provider-card__body">
                    <div class="provider-card__name">
                      <i class="fas fa-truck me-2"></i>
                      {{ line.get('guinchoProviderName')?.value || ('#' + line.get('guinchoProviderId')?.value) }}
                    </div>
                    <div class="provider-card__meta">
                      <span>{{ line.get('description')?.value }}</span>
                    </div>
                  </div>
                  <div class="provider-card__actions">
                    <button type="button" class="btn btn-outline-primary btn-sm" (click)="openGuinchoProviderPicker(i)">
                      <i class="fas fa-exchange-alt me-1"></i> Trocar
                    </button>
                    <button type="button" class="btn btn-outline-secondary btn-sm" (click)="clearGuinchoProvider(line)">
                      <i class="fas fa-times me-1"></i> Limpar
                    </button>
                  </div>
                </div>
                <ng-template #guinchoEmpty>
                  <div class="provider-empty">
                    <div class="provider-empty__text">
                      <i class="fas fa-truck"></i>
                      Selecione um fornecedor com tag de guincho
                    </div>
                    <button type="button" class="btn btn-primary btn-sm" (click)="openGuinchoProviderPicker(i)">
                      <i class="fas fa-search me-1"></i> Selecionar guincho
                    </button>
                  </div>
                </ng-template>
              </div>
              <div class="col-md-3">
                <label class="form-label">Descrição</label>
                <input type="text" class="form-control" formControlName="description" placeholder="Guincho — fornecedor">
              </div>
              <div class="col-md-1 line-item__remove">
                <button
                  type="button"
                  class="btn btn-outline-danger btn-sm"
                  title="Remover guincho"
                  [disabled]="services.length === 1"
                  (click)="removeService(i)">
                  <i class="fas fa-trash"></i>
                </button>
              </div>
            </div>
            <div class="row g-3 align-items-start" *ngIf="!isGuinchoLine(line)">
              <div class="col-md-3">
                <label class="form-label">Natureza *</label>
                <select
                  class="form-select"
                  formControlName="maintenanceKind"
                  (change)="onMaintenanceKindChange(line)">
                  <option *ngFor="let k of maintenanceKinds" [ngValue]="k.value">{{ k.label }}</option>
                </select>
              </div>
              <div class="col-md-8">
                <label class="form-label">Descrição *</label>
                <input type="text" class="form-control" formControlName="description" placeholder="Ex: Troca de pastilhas">
                <div class="invalid-feedback d-block" *ngIf="isLineInvalid(line, 'description')">
                  Informe a descrição.
                </div>
              </div>
              <div class="col-md-1 line-item__remove">
                <button
                  type="button"
                  class="btn btn-outline-danger btn-sm"
                  title="Remover serviço"
                  [disabled]="services.length === 1"
                  (click)="removeService(i)">
                  <i class="fas fa-trash"></i>
                </button>
              </div>
            </div>

            <div class="row g-3 align-items-start mt-1" *ngIf="!isPreventiva(line); else preventivaNoteService">
              <div class="col-md-2">
                <label class="form-label">Quantidade *</label>
                <input type="number" class="form-control" formControlName="quantity" min="1" step="1">
              </div>
              <div class="col-md-3">
                <label class="form-label">Valor do serviço *</label>
                <input type="number" class="form-control" formControlName="unitValue" min="0.01" step="0.01">
                <div class="invalid-feedback d-block" *ngIf="isLineInvalid(line, 'unitValue')">
                  Informe o valor.
                </div>
              </div>
              <div class="col-md-3" *ngIf="canViewChargePercent">
                <label class="form-label">% a mais</label>
                <input type="number" class="form-control" formControlName="chargePercent" min="0" max="1000" step="0.01" placeholder="0">
                <small class="text-muted">Cobrado a mais sobre o valor do serviço.</small>
              </div>
              <div [class.col-md-4]="canViewChargePercent" [class.col-md-7]="!canViewChargePercent">
                <label class="form-label">Valor de cobrança</label>
                <div class="line-total">{{ formatCurrency(lineTotal(line)) }}</div>
                <small class="text-muted">{{ canViewChargePercent ? 'Qtd × valor × (1 + %/100)' : 'Qtd × valor' }}</small>
              </div>
            </div>
            <ng-template #preventivaNoteService>
              <div class="preventiva-note mt-2">
                <i class="fas fa-info-circle me-1"></i>
                Linha preventiva — sem cobrança ao cliente.
                <strong class="ms-2">{{ formatCurrency(0) }}</strong>
              </div>
            </ng-template>
          </div>
        </div>
      </div>

      <div class="form-card">
        <div class="form-card__header">
          <h6 class="form-card__title">
            <i class="fas fa-boxes"></i>
            Produtos e peças
          </h6>
          <button type="button" class="btn btn-outline-primary btn-sm" (click)="addProduct()">
            <i class="fas fa-plus me-1"></i> Adicionar produto
          </button>
        </div>

        <div class="empty-lines" *ngIf="products.length === 0">
          Nenhum produto adicionado. Use “Adicionar produto” quando o orçamento incluir peças ou materiais.
        </div>

        <div formArrayName="products">
          <div
            class="line-item"
            *ngFor="let line of products.controls; let i = index"
            [formGroupName]="i"
            [class.line-item--preventiva]="isPreventiva(line)">
            <div class="line-item__number">
              Produto {{ i + 1 }}
              <span class="line-kind-badge" [class.line-kind-badge--preventiva]="isPreventiva(line)">
                {{ isPreventiva(line) ? 'Preventiva' : 'Corretiva' }}
              </span>
            </div>
            <div class="row g-3 align-items-start">
              <div class="col-md-3">
                <label class="form-label">Natureza *</label>
                <select
                  class="form-select"
                  formControlName="maintenanceKind"
                  (change)="onMaintenanceKindChange(line)">
                  <option *ngFor="let k of maintenanceKinds" [ngValue]="k.value">{{ k.label }}</option>
                </select>
              </div>
              <div class="col-md-8">
                <label class="form-label">Descrição *</label>
                <input type="text" class="form-control" formControlName="description" placeholder="Ex: Pastilha de freio">
                <div class="invalid-feedback d-block" *ngIf="isLineInvalid(line, 'description')">
                  Informe a descrição.
                </div>
              </div>
              <div class="col-md-1 line-item__remove">
                <button type="button" class="btn btn-outline-danger btn-sm" title="Remover produto" (click)="removeProduct(i)">
                  <i class="fas fa-trash"></i>
                </button>
              </div>
            </div>

            <div class="row g-3 align-items-start mt-1" *ngIf="!isPreventiva(line); else preventivaNoteProduct">
              <div class="col-md-2">
                <label class="form-label">Quantidade *</label>
                <input type="number" class="form-control" formControlName="quantity" min="1" step="1">
              </div>
              <div class="col-md-3">
                <label class="form-label">Valor da peça *</label>
                <input type="number" class="form-control" formControlName="unitValue" min="0.01" step="0.01">
                <div class="invalid-feedback d-block" *ngIf="isLineInvalid(line, 'unitValue')">
                  Informe o valor.
                </div>
              </div>
              <div class="col-md-3" *ngIf="canViewChargePercent">
                <label class="form-label">% a mais</label>
                <input type="number" class="form-control" formControlName="chargePercent" min="0" max="1000" step="0.01" placeholder="0">
                <small class="text-muted">Cobrado a mais sobre o valor da peça.</small>
              </div>
              <div [class.col-md-4]="canViewChargePercent" [class.col-md-7]="!canViewChargePercent">
                <label class="form-label">Valor de cobrança</label>
                <div class="line-total">{{ formatCurrency(lineTotal(line)) }}</div>
                <small class="text-muted">{{ canViewChargePercent ? 'Qtd × valor × (1 + %/100)' : 'Qtd × valor' }}</small>
              </div>
            </div>
            <ng-template #preventivaNoteProduct>
              <div class="preventiva-note mt-2">
                <i class="fas fa-info-circle me-1"></i>
                Linha preventiva — sem cobrança ao cliente.
                <strong class="ms-2">{{ formatCurrency(0) }}</strong>
              </div>
            </ng-template>
          </div>
        </div>
      </div>

      <div class="budget-total-card">
        <span>Total geral do orçamento</span>
        <strong>{{ formatCurrency(totalPreview) }}</strong>
      </div>

      <div class="form-card" *ngIf="!isEditMode">
        <h6 class="form-card__title">
          <i class="fas fa-clock"></i>
          Registro da ação
        </h6>
        <div class="row g-3">
          <div class="col-md-6">
            <label class="form-label" for="recordedAt">Data e hora de geração do orçamento</label>
            <input id="recordedAt" type="datetime-local" class="form-control" formControlName="recordedAt">
            <small class="text-muted d-block mt-1">
              Use para lançamentos retroativos. Deixe a data/hora atual se o orçamento está sendo criado agora.
            </small>
          </div>
        </div>
      </div>

      <div class="form-actions">
        <button type="button" class="btn btn-secondary" (click)="cancel()" [disabled]="submitting">
          Cancelar
        </button>
        <button type="submit" class="btn btn-primary" [disabled]="submitting">
          <i class="fas fa-spinner fa-spin me-1" *ngIf="submitting"></i>
          <i class="fas fa-check me-1" *ngIf="!submitting"></i>
          {{ submitting ? (isEditMode ? 'Salvando...' : 'Criando...') : (isEditMode ? 'Salvar alterações' : 'Criar orçamento') }}
        </button>
      </div>
    </form>
  </div>

  <app-provider-selection-modal (providerSelected)="onProviderSelected($event)"></app-provider-selection-modal>
</app-side-menu>
